import withModal from '../../../modal/withModal';
import CardDesignerNameModal from './CardDesignerNameModal';

export const CARD_DESIGNER_NAME_MODAL = 'modal/CARD_DESIGNER_NAME_MODAL';

export default withModal(CardDesignerNameModal, {
  name: CARD_DESIGNER_NAME_MODAL,
  size: 'sm',
  type: 'full',
});
